export enum InstagramAccountTab {
  account = "account",
}

export enum InstagramAccountMenuTab {
  generalInfo = "generalInfo",
}
